import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatPaginator, MatSort } from '@angular/material';
import { HtmlEditorService, ImageService, LinkService, ToolbarService } from '@syncfusion/ej2-angular-richtexteditor';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/startWith';
import { fuseAnimations } from '../../../../../core/animations';
import { Noticia } from '../../../../models/noticias/noticia';
import { NoticiasService } from '../../../../services/noticias/noticias.service';
import { TipoNoticiasService } from '../../../../services/tipo-noticias/tipo-noticia.service';
import { TranslationService } from '../../../../services/translation/translation.service';
import { AddNoticiaComponent } from './components/add-noticia/add-noticia.component';
import { NoticiasDataSource } from './noticiasDataSource';
import { NoticiasDatabase } from './noticiasDatabase';
import { AddMenuComponent } from './components/add-menu/add-menu.component';
import { SweetAlertService } from '../../../../services/sweet-alert/sweet-alert.service';

@Component({
    selector: 'fuse-management-noticias',
    templateUrl: './noticias.component.html',
    styleUrls: ['./noticias.component.scss'],
    animations: fuseAnimations,
    providers: [ToolbarService, LinkService, ImageService, HtmlEditorService]
})
export class NoticiasComponent implements OnInit, OnDestroy {
    @BlockUI('tracker') blockUI: NgBlockUI;
    displayedColumns = ['Name', 'Description', 'Publicado','EnPortada','Menu','Actions'];
    noticiasDatabase;
    dataSource: NoticiasDataSource | null;
    confirmDialogRef: any;
    tipoNoticias = [];


    private sub: any;
    selectedTipo = "";

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('filter') filter: ElementRef;

    constructor(
        public dialog: MatDialog,
        private translationService: TranslationService,
        private noticiasService: NoticiasService,
        private tipoNoticiasService: TipoNoticiasService,
        private sweetAlertService: SweetAlertService,
    ) {
    }

    ngOnInit() {
        this.blockUI.start(this.translationService.loading);


        this.tipoNoticiasService.getAll().subscribe(e => {
            this.tipoNoticias = [...e];
            this.noticiasDatabase = new NoticiasDatabase(this.noticiasService, this.tipoNoticias);
            this.dataSource = new NoticiasDataSource(this.noticiasDatabase, this.paginator, this.sort);
            this.sub = Observable.fromEvent(this.filter.nativeElement, 'keyup')
                .debounceTime(150)
                .distinctUntilChanged()
                .subscribe(() => {
                    if (!this.dataSource) {
                        return;
                    }
                    this.dataSource.filter = this.filter.nativeElement.value;
                });
            this.blockUI.stop();
        });


        
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    add() {
        const noticia = new Noticia();

        const config: MatDialogConfig = {
            // height: '75%',
            width: '50%',
            disableClose: true,
            panelClass: 'ea-dialog',
            data: {
                mode: 'new',
                noticia: Object.assign({}, noticia)
            }
        };

        this.confirmDialogRef = this.dialog.open(AddNoticiaComponent, config);

        this.confirmDialogRef.afterClosed().subscribe(result => {
            this.noticiasDatabase.refresh();
        });
    }

    editOrView(mode: string, noticia: Noticia) {
        console.log('noticia>>>', noticia);
        const config: MatDialogConfig = {
            // height: '75%',
            width: '50%',
            disableClose: true,
            panelClass: 'ea-dialog',
            data: {
                mode: mode,
                noticia: Object.assign({}, noticia)
            }
        };

        this.confirmDialogRef = this.dialog.open(AddNoticiaComponent, config);

        this.confirmDialogRef.afterClosed().subscribe(result => {
            console.log("JJJJJJJJJJJJJJJJJJJJJJ");
            this.noticiasDatabase.refresh();
        });
    }

    menu() {
        const noticia = new Noticia();
        const config: MatDialogConfig = {
            width: '50%',
            disableClose: true,
            panelClass: 'ea-dialog',
            data: {
                mode: 'new',
                noticia: Object.assign({}, noticia)
            }
        };

        this.confirmDialogRef = this.dialog.open(AddMenuComponent, config);
        this.confirmDialogRef.afterClosed().subscribe(result => {
            if (result !== true) {
                // this.noticiasDatabase.add(result);
                // this.noticiasDatabase.refresh();
            }
        });
    }

    delete(n: any) {
        const noticia = new Noticia();
        noticia.Id = n.Id;
        this.sweetAlertService.question(this.translationService.confirmation, "¿Eliminar noticia?", this.translationService.yes, this.translationService.no, () => {
            this.noticiasService.delete(noticia).subscribe(response => {
                console.log("dato =" + response.ResultCode);
                if (response.ResultCode == 1) {
                    this.noticiasDatabase.delete(noticia);
                    const index = this.noticiasService.noticias.findIndex(s => s.Id == noticia.Id);
                    if (index >= 0) {
                        this.noticiasService.noticias.splice(index, 1);
                        delete this.noticiasService.noticiasObject[noticia.Id];
                    }
                    this.sweetAlertService.success(this.translationService.success, this.translationService.deletedCorrectly, null);
                } else {
                    this.translationService.translate('ERRORS.ERROR_REQUEST', response.ResultMsg, (res: string) => {
                        this.sweetAlertService.error('Error', res, null);
                    });
                }
            }, error => {
                this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                    this.sweetAlertService.error('Error', res, null);
                });
            });
        }, () => {
            console.log('FuseStudentComponent > delete > canceled');
        });
    }

    filterPublicado(manually: boolean) {
        this.dataSource.filterPublicado(manually);
    }

    filterEnPortada(manually: boolean) {
        this.dataSource.filterEnPortada(manually);
    }
    
    filterTipo(tipo: any) {
        this.dataSource.filterTipo(tipo);
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/noticias/noticias.component.ts